import axios from 'axios'
// import * as turf from '@turf/turf'
// import state from './state'

export const setCenter = ({ commit }, latlng) => commit('setCenter', latlng)
export const setZoom = ({ commit }, zoom) => commit('setZoom', zoom)

export const setWatchid = ({ commit }, watchid) => commit('setWatchid', watchid)
export const clearWatchid = ({ commit }) => commit('clearWatchid')
export const setPosition = ({ commit }, position) => commit('setPosition', position)

export const setWeather = ({ commit }, weather) => commit('setWeather', weather)

// export const setCenter = ({ commit }, latlng) => {
//   commit('setCenter', latlng)
//   // setting gap to track, if greated than 5km get new POIs
//   const gap = 5
//   // function used to set POIs
//   const setPois = () => {
//     getPois(latlng).then(res => {
//       if (res.data.query && res.data.query.pages) {
//         commit('setPois', Object.assign({}, res.data.query.pages))
//       }
//     })
//   }
//   // if POIs track enabled, find out if it's needed to request POIs
//   if (state.poisTrack) {
//     const from = turf.point([latlng.lng, latlng.lat])
//     if (!state.poisOrigins.length) {
//       // first request
//       setPois()
//     } else if (state.poisOrigins.length === 1) {
//       // calculate the distance between current center and last request
//       // if more than 5km, getPois
//       const origin = state.poisOrigins[0]
//       const to = turf.point([origin.lng, origin.lat])
//       const distance = turf.distance(from, to)
//       if (distance > gap) setPois()
//     } else if (state.poisOrigins.length === 2) {
//       // calculate the distance to the line
//       const coords = state.poisOrigins.map(pt => [pt.lng, pt.lat])
//       const line = turf.lineString(coords)
//       const distance = turf.pointToLineDistance(from, line)
//       if (distance > gap) setPois()
//     } else {
//       // calculate the convex polygon https://turfjs.org/docs/#convex
//       // then the distance https://github.com/Turfjs/turf/issues/252#issuecomment-95216735
//       const origins = state.poisOrigins.map(latlng => turf.point([latlng.lng, latlng.lat]))
//       const collection = turf.featureCollection(origins)
//       const hull = turf.convex(collection)
//       const vertices = turf.explode(hull)
//       const closestVertex = turf.nearest(from, vertices)
//       const distance = turf.distance(from, closestVertex)
//       if (distance > gap) setPois()
//     }
//   }
// }

export const getPois = (latlng, lang = 'fr') => {
  const url = `https://${lang}.wikipedia.org/w/api.php?origin=*&action=query&generator=geosearch&prop=coordinates|pageimages&ggscoord=${latlng.lat}|${latlng.lng}&format=json&gsradius=10000&gslimit=100`
  return axios.get(url)
}

export const getPage = (pageid, lang = 'fr') => {
  const url = `https://${lang}.wikipedia.org/w/api.php?format=json&action=query&prop=extracts&exintro&explaintext&redirects=1&pageids=${pageid}`
  return axios.get(url)
}

export const setPoisTrack = ({ commit }, payload) => commit('setPoisTrack', payload)
